import {
  Box,
  styled,
  Typography,
  CircularProgress,
  Button,
} from '@mui/material'
import HistoryIcon from '@mui/icons-material/History'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

export const LoadingBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  background: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(8px)',
  flexDirection: 'column',
  gap: 16,
})

export const RoomViewContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$isWaitingRoomHidden',
})<{ $isWaitingRoomHidden: boolean }>(({ $isWaitingRoomHidden }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  background: '#FBFBFD',
  ...($isWaitingRoomHidden && {
    gap: '20px',
  }),
}))

export const ErrorBox = styled(Box)({
  p: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
})

export const ErrorMessage = styled(Typography)({
  fontWeight: 500,
  letterSpacing: '-0.01em',
})

export const RoomsLayoutContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden',
  flex: 1,

  padding: theme.spacing(0.5),
  gap: theme.spacing(0.8),

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5),
    gap: theme.spacing(0.8),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(1.2),
    gap: theme.spacing(1.1),
  },
}))

export const StyledCircularProgress = styled(CircularProgress)()
StyledCircularProgress.defaultProps = {
  size: 32,
  thickness: 4,
}

export const LoadingTitle = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: '-0.01em',
  color: theme.palette.primary.main,
}))

export const StyledMenuButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  bottom: 6,
  right: 10,
  borderRadius: 8,
  opacity: 0.7,
  textTransform: 'none',
  fontWeight: 600,
  padding: '4px 14px',
  boxShadow: 'none',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 'none',
    background: theme.palette.primary.dark,
    transform: 'translateY(-1px)',
  },
}))

export const StyledHistoryIcon = styled(HistoryIcon)(() => ({
  fontSize: 25,
}))

export const ToggleIcon = styled(ChevronRightIcon)(() => ({
  fontSize: 20,
  color: 'white',
}))

export const TopToggleButton = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 80,
  left: 0,
  width: 25,
  height: 40,
  background: theme.palette.primary.main,
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1100,
  opacity: 0.7,
  textTransform: 'none',
  boxShadow: 'none',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 'none',
    background: theme.palette.primary.dark,
    transform: 'translateY(-1px)',
  },
}))
